/*
 * @Author: <pcjser> 
 * @Date: 2018-04-19 09:12:29 
 * @Last Modified by: pcjser
 * @Last Modified time: 2018-06-12 17:15:11
 */
import axios from 'axios';
import qs from 'qs';
import {
  Toast
} from 'antd-mobile';

const request = (path = '', params = {}, type = 'POST', tag = false) => {
  const username = window.localStorage.getItem("fw-username");
  const token = window.localStorage.getItem("fw-token");
  const platform = window.localStorage.getItem("fw-platform");
  const indexPage = window.location.href.indexOf("gameCenter") > 0
  if (!username && !tag && platform === "fengwanI" && !indexPage) {
    return new Promise((resolve, reject) => {
      login({
        token
      }).then(res => {
        if (res.code === 200) {
          localStorage.setItem('fw-username', res.payload.username)
          getData(path, params, type).then(resolve).catch(reject)
        } else if (res.code === 401 && platform === 'fengwanI') {
          window.localStorage.removeItem('fw-username')
          window.webkit.messageHandlers.FW_out.postMessage(null)
        } else {
          window.webkit.messageHandlers.FW_log.postMessage("front-login:" + res.code)
        }
      }).catch(reject)
    })
  } else {
    return getData(path, params, type);
  }
}

const getData = (path = '', params = {}, type = 'POST') => {
  const platform = window.localStorage.getItem('fw-platform');
  const username = window.localStorage.getItem("fw-username");
  const indexPage = window.location.href.indexOf("gameCenter") > 0
  return new Promise((resolve, reject) => {
    if (type === 'POST') {
      let urlParams = qs.stringify(params);
      axios.post(path, urlParams).then(res => {
        let data = res.data;
        if ((data.status === 401 || data.code === 401) && !indexPage && username) {
          window.localStorage.removeItem('fw-username')
          if (platform === "fengwanI") {
            window.webkit.messageHandlers.FW_log.postMessage(indexPage + "|" + username)
            window.webkit.messageHandlers.FW_out.postMessage(null)
          } else {
            window.localStorage.setItem('fw-loginBackUrl', window.location.href)
            Toast.loading('登录失效，跳转中', 1, () => {
              window.location.replace('/login.html?sourceDir=fengwan&redirect_uri=' + encodeURIComponent(`/fengwan/#/login`));
            }, true)
          }
        } else {
          // if(path.indexOf("game_center") > 0 && platform === "fengwanI") {
          //   window.webkit.messageHandlers.FW_log.postMessage("front-gameCenter:" + JSON.stringify(data))
          // }
          resolve(data)
        }
      }).catch(err => {
        reject(err)
      })
    }
  })
}

export const APIShare = params => request('/index.php?d=api&c=wechat&m=jssdk', params, 'POST', true) //微信分享
export const login = params => request('/index.php?c=ActivityAction&m=login', params, 'POST', true) //用户登录
export const logout = params => request('/index.php?c=ActivityAction&m=logout', params, 'POST', true) //用户退出
export const loginStatus = params => request('/index.php?c=ActivityAction&m=status', params) //判断用户登录状态
export const getGameList = params => request('/index.php?c=RplayerAction&m=game_center', params) //获取游戏列表
export const getGameInfo = params => request('/index.php?c=ActivityAction&m=find', params) //获取页面游戏信息
export const getRoles = params => request('/index.php?c=ActivityAction&m=roles', params) //获取用户角色
export const chargeSubmit = params => request('/index.php?c=ActivityAction&m=handle', params) //提交充值
export const paySubmit = params => request('/index.php?c=ActivityAction&m=pay', params) //唤起支付
export const getAwardList = params => request('/index.php?c=ActivityAction&m=rewards', params) //获取用户奖励列表
export const getResultAwards = params => request('/index.php?c=ActivityAction&m=log', params) //获取结果页奖励
export const getUserInfo = params => request('/index.php?c=RplayerAction&m=user_info', params) //获取用户信息
export const getUserCard = params => request('/index.php?c=RplayerAction&m=user_card', params) //获取用户卡券列表
export const getUserGift = params => request('/index.php?c=RplayerAction&m=user_gift', params) //获取用户礼包列表
/* 商城 */
export const getGoodsList = params => request('/index.php?d=api&c=MallVip&m=goodsList', params) //获取商品列表
export const getUserTreasure = params => request('/index.php?d=api&c=MallVip&m=usersWealth', params) //获取用户财富值
export const getGoodsDetail = params => request('/index.php?d=api&c=MallVip&m=goodsDetail', params) //获取商品详情
export const createOrder = params => request('/index.php?d=api&c=MallVip&m=consume', params) //创建订单
export const postAddress = params => request('/index.php?d=api&c=MallVip&m=usersAddress', params) //更新收货地址
export const getAddress = params => request('/index.php?d=api&c=MallVip&m=initAddress', params) //获取收货地址
export const getTreasureList = params => request('/index.php?d=api&c=MallVip&m=wealthList', params) //获取财富明细
export const userExchange = params => request('/index.php?d=api&c=MallVip&m=consumeList', params) //获取用户兑换明细
export const getOrderDetail = params => request('/index.php?d=api&c=MallVip&m=consumeDetail', params) //获取用户兑换明细

/* 广告 */
export const getAdvertisement = params => request('/index.php?c=RplayerAction&m=get_ad', params, 'POST', true) //获取广告详情



// WEBPACK FOOTER //
// ./src/service/fetch.js